import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FormControl, InputLabel, MenuItem, Select, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function ChangePricesDialog({
    open,
    handleClose,
    prices,
    onSubmit
  }) {

    const { t } = useTranslation();

    const handleSubmit = (e) => {
        e.preventDefault()
        const prices = []
        for (const el of e.target){
          if(el.id){
            prices.push({
              id: el.id,
              value: el.value
            })
          }
        }
        onSubmit(prices)
    }

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <Box sx={{
            width: '100%'
        }}>
            <DialogTitle>{t("views.productsManager.changePlanPrices")}</DialogTitle>
            <DialogContentText px={3}>
                {t("views.productsManager.pricesForEachPeriod")}
            </DialogContentText>
            <Box component="form" sx={{
                    display:'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }} onSubmit={handleSubmit} onReset={handleClose}>
                <DialogContent sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    width: '100%'
                }}>
                    <TextField required variant="outlined" type="number" placeholder={t("views.productsManager.monthPricePlaceholder")} id="month" label={t("views.productsManager.monthPriceLabel")} fullWidth name='monthPrice' defaultValue={prices.find(pri => pri.recurring.interval == 'month')?.unit_amount} focused />
                    <TextField required variant="outlined" type="number" placeholder={t("views.productsManager.yearPricePlaceholder")} id="year" label={t("views.productsManager.yearPriceLabel")} fullWidth name='yearPrice' defaultValue={prices.find(pri => pri.recurring.interval == 'year')?.unit_amount} focused />
                </DialogContent>
                <DialogActions sx={{
                    alignSelf: 'end'
                }}>
                    <Button type='reset'>{t("views.productsManager.cancel")}</Button>
                    <Button type="submit" color='success'>{t("views.productsManager.save")}</Button>
                </DialogActions>
            </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
}